import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FocusOn } from 'react-focus-on';
import { isIosMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { hideDialog } from '../../../base/dialog/actions';
import { MY_SETTINGS_TOOLBOX_VISIBLE, SETTINGS_TOOLBOX_VISIBLE } from '../../actionTypes';
import Toolbox from './Toolbox';
/**
 * Implementation of a button for toggling fullscreen state.
 */
class SubToolbar extends Component {
    constructor(props) {
        super(props);
        this.onBackdropClick = this.onBackdropClick.bind(this); // Binding 'this'
    }
    /**
    * Handles clicking the button, and toggles fullscreen.
    *
    * @private
    * @returns {void}
    *
    */
    // _handleClick() {
    //     const { dispatch, overflowMenuVisible } = this.props;
    //     sendAnalytics(createToolbarEvent(
    //         'toggle.fullscreen',
    //         {
    //             enable: !_fullScreen
    //         }));
    //     dispatch(closeOverflowMenuIfOpen());
    //     dispatch(setFullScreen(!_fullScreen));
    // }
    onBackdropClick(event) {
        const { dispatch, toolBoxContainerStyle } = this.props;
        dispatch(hideDialog());
        if (toolBoxContainerStyle == 'sub-toolbar-box') {
            let clickedButton = document.querySelector(".mySettingsButton");
            let subMenu = document.querySelector(".sub-toolbar-box");
            if (subMenu && !subMenu.contains(event?.target) && clickedButton && !clickedButton.contains(event?.target)) {
                dispatch({
                    mySettingsVisible: false,
                    type: MY_SETTINGS_TOOLBOX_VISIBLE
                });
            }
        }
        else if (toolBoxContainerStyle == 'settings-sub-toolbar-box') {
            let clickedButton = document.querySelector(".settingsButton");
            let subMenu = document.querySelector(".settings-sub-toolbar-box");
            if (subMenu && !subMenu.contains(event?.target) && clickedButton && !clickedButton.contains(event?.target)) {
                dispatch({
                    settingsVisible: false,
                    type: SETTINGS_TOOLBOX_VISIBLE
                });
            }
        }
    }
    /**
   * Implements React's {@link Component#render}.
   *
   * @inheritdoc
   */
    render() {
        const { subToolbar, toolBoxContainerStyle, toolBarTop, toolBarLeft } = this.props;
        return (React.createElement(FocusOn, { onClickOutside: this.onBackdropClick },
            React.createElement("div", null,
                React.createElement(Toolbox, { toolbarButtons: subToolbar, callAction: 'Sub', toolBoxContainerStyle: toolBoxContainerStyle, toolBarTop: toolBarTop, toolBarLeft: toolBarLeft }))));
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        // overflowMenuVisible: state['features/toolbox'].overflowMenuVisible,
        visible: !isIosMobileBrowser()
    };
};
export default translate(connect(mapStateToProps)(SubToolbar));
